import { gql, useQuery } from "@apollo/client";
import { TranslationSupportQuery } from "./__generated__/useTranslationSupportQuery";

export const TRANSLATION_SUPPORT_QUERY = gql`
    query TranslationSupportQuery($userPublicId: String, $linkHash: String) {
        customer(userPublicId: $userPublicId, linkHash: $linkHash) {
            publicId
            patientAppTranslationSupportContext {
                ctaMessage
            }
        }
    }
`;

type Props = {
    userPublicId?: string;
    linkHash?: string;
    skip?: boolean;
};

export function useTranslationSupportQuery({ userPublicId, skip, linkHash }: Props) {
    return useQuery<TranslationSupportQuery>(TRANSLATION_SUPPORT_QUERY, {
        variables: { userPublicId, linkHash },
        skip,
    });
}
